<template>
  <div class="scheduleIndexRentalContractEditFormModal">
    <BsModal
      ref="rentalContractModalRef"
      :modal-dialog-settings="['modal-fullscreen']"
    >
      <!-- header -->
      <!-- <template v-slot:header></template> -->
      <!-- ./header -->

      <!-- body -->
      <div class="container-fluid">
        <article id="pg_check" class="py-3 py-lg-4 py-xl-5">
          <!-- ―――― #pg_check ―――― -->
          <div class="close" @click="hideRentalContractModal()">
            <div class="js-colorbox-close">&nbsp;</div>
          </div>

          <!-- ―――― #index ―――― -->
          <section id="index" class="fs-small lh-md mb-s">
            <RentalContractForm />
          </section>
          <!-- ―――― /#index ―――― -->

          <!-- ―――― #check ―――― -->
          <section id="check" class="fs-small lh-md mb-s">
            <CarChecksheetForm />
          </section>
          <!-- ―――― /#check ―――― -->

          <!-- ―――― #submit ―――― -->
          <section id="submit">
            <RentalContractSubmit />
          </section>
          <!-- ―――― /#submit ―――― -->

          <!-- ―――― /#pg_check ―――― -->
        </article>
      </div>
      <!-- ./body -->
    </BsModal>
  </div>
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent, ref } from "vue";
import { BsModal } from "bs-modal-vue";
/* Import Compoments. */
import RentalContractForm from "./rentalContractModal/rentalContract.vue";
import CarChecksheetForm from "./rentalContractModal/carChecksheet.vue";
import RentalContractSubmit from "./rentalContractModal/rentalContractSubmit.vue";
/* Import Variables. */
import {
  rentalContractModalRef,
  hideRentalContractModal,
} from "../../compositions/rentContract/modal";
/* Import Funcrions */

export default defineComponent({
  components: {
    BsModal,
    RentalContractForm,
    CarChecksheetForm,
    RentalContractSubmit,
  },
  setup() {
    rentalContractModalRef.value = ref<any>(null);

    return {
      /* functions */
      hideRentalContractModal,
      /* variables */
      rentalContractModalRef,
    };
  },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
